// Abertura em React (dono, 16/10/2026) — GÊMEA da tela da logo do
// public/index.html: mesmas classes (.ta-abertura, CSS lá), mesmo desenho,
// setas girando em volta da caixinha. Aparece enquanto o login é conferido
// (e no retorno do "Entrar com Google"); como é idêntica à do HTML, a troca
// entre as duas não aparece.
//
// AberturaPronta: vai dentro do <Suspense> do App. Só monta quando o código
// da tela já baixou, então avisa "pronto" na hora certa — exceto na home e na
// página do produto, que avisam sozinhas quando os dados chegam.
import React, { useEffect } from 'react';
import { marcarAberturaPronta } from '../lib/abertura';

const SQUIRCLE = 'M 50.45,0 L 69.55,0 C 91.33,0 99.16,3.35 107.7,12.3 C 116.65,20.84 120,28.67 120,50.45 L 120,69.55 C 120,91.33 116.65,99.16 107.7,107.7 C 99.16,116.65 91.33,120 69.55,120 L 50.45,120 C 28.67,120 20.84,116.65 12.3,107.7 C 3.35,99.16 0,91.33 0,69.55 L 0,50.45 C 0,28.67 3.35,20.84 12.3,12.3 C 20.84,3.35 28.67,0 50.45,0 Z';

export const TelaAbertura = ({ aviso = null }) => (
  <div className="ta-abertura" role="status" aria-label="Abrindo o Tô Alugando">
    <div className="ta-logo" aria-hidden="true">
      <svg viewBox="0 0 120 120">
        <defs>
          <linearGradient id="ta-g-react" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#f97316" /><stop offset="1" stopColor="#ea580c" />
          </linearGradient>
        </defs>
        <path fill="url(#ta-g-react)" d={SQUIRCLE} />
        <g fill="#fff" stroke="#fff" strokeLinejoin="round" strokeLinecap="round">
          <polygon points="60.00,39.25 76.50,48.55 60.00,57.85 43.50,48.55" strokeWidth="2.5" />
          <polygon points="40.21,54.25 56.71,63.55 56.71,78.85 40.21,69.55" strokeWidth="2.5" opacity=".9" />
          <polygon points="79.79,54.25 63.29,63.55 63.29,78.85 79.79,69.55" strokeWidth="2.5" opacity=".74" />
        </g>
      </svg>
      <svg className="ta-setas" viewBox="0 0 120 120">
        <g fill="#fff" stroke="#fff" strokeLinejoin="round" strokeLinecap="round">
          <path d="M 24.29 47.00 A 38 38 0 0 1 89.11 35.57" fill="none" strokeWidth="7" />
          <path d="M 97.47 45.53 L 82.22 41.36 L 96.00 29.79 Z" strokeWidth="3" />
          <path d="M 95.71 73.00 A 38 38 0 0 1 30.89 84.43" fill="none" strokeWidth="7" />
          <path d="M 22.53 74.47 L 37.78 78.64 L 24.00 90.21 Z" strokeWidth="3" />
        </g>
      </svg>
    </div>
    <p>Tô <b>Alugando</b></p>
    <small>Marketplace de locações</small>
    {aviso && <p className="ta-aviso">{aviso}</p>}
  </div>
);

const TELAS_QUE_AVISAM_SOZINHAS = new Set(['home', 'detalhes']);

export const AberturaPronta = ({ tela }) => {
  useEffect(() => {
    if (!TELAS_QUE_AVISAM_SOZINHAS.has(tela)) marcarAberturaPronta();
  }, [tela]);
  return null;
};

export default TelaAbertura;
